<div class="bn-email-not-verified">
  <div class="bn-email-not-verified__container">
    <div class="bn-email-not-verified__container__title">Hello{{ userFirstName ? ', ' + userFirstName : '' }}!</div>
    <div class="text-700-bold mt-3">Your email is not verified yet.</div>
    <div class="text-500-regular mt-3">To start using our services, please verify your email address.</div>
    <div class="mt-3">
      <bn-web-ui-button
        itemStyle="secondary"
        size="lg"
        [disabled]="isLoading"
        [loading]="isLoading"
        (click)="onResendClick()"
        >Resend Email
      </bn-web-ui-button>
    </div>
    <img
      alt="Unauthorized"
      class="bn-email-not-verified__container__image"
      src="/assets/web-ui/images/bunny-person-pointing-web-form.svg"
      [ngStyle]="{
        'width.px': 493,
      }" />
  </div>
</div>
